"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryBlock = exports.ObservableQueryBlockInner = void 0;
const chain_query_1 = require("../../chain-query");
const mobx_1 = require("mobx");
const unit_1 = require("@keplr-wallet/unit");
class ObservableQueryBlockInner extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter, paramHeight) {
        super(kvStore, chainId, chainGetter, `/blocks/${paramHeight}`);
        this.paramHeight = paramHeight;
        mobx_1.makeObservable(this);
    }
    /**
     * Return the block height.
     * If fetching is not completed or failed, return the 0 Int.
     */
    get height() {
        if (!this.response) {
            return new unit_1.Int("0");
        }
        return new unit_1.Int(this.response.data.block.header.height);
    }
}
__decorate([
    mobx_1.computed
], ObservableQueryBlockInner.prototype, "height", null);
exports.ObservableQueryBlockInner = ObservableQueryBlockInner;
class ObservableQueryBlock extends chain_query_1.ObservableChainQueryMap {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, (height) => {
            const param = height === "latest" ? height : parseInt(height);
            return new ObservableQueryBlockInner(this.kvStore, this.chainId, this.chainGetter, param);
        });
        this.kvStore = kvStore;
        this.chainId = chainId;
        this.chainGetter = chainGetter;
    }
    getBlock(height) {
        return this.get(height.toString());
    }
}
exports.ObservableQueryBlock = ObservableQueryBlock;
//# sourceMappingURL=index.js.map